import { render, staticRenderFns } from "./confirmPhoneNumber.vue?vue&type=template&id=d163ca48&scoped=true&"
import script from "./confirmPhoneNumber.vue?vue&type=script&lang=js&"
export * from "./confirmPhoneNumber.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d163ca48",
  null
  
)

export default component.exports